import React from 'react';
import { Text } from '../../../components';
import NewSummaryDetails from './NewSummaryDetails';
import { NewRMCard } from '../NewRMCard';
import classNames from 'classnames';

export const NewSummaryDetailsCard = ({ title, details, headerRight, className = '', ...props }) => {
    return (
        <NewRMCard className={classNames(className, 'new-summary-details-card')} showMoreIcon={false} {...props}>
            <header>
                {title && (
                    <Text size="large" color="secondary">
                        {title}
                    </Text>
                )}
                {headerRight && (
                    <div className="header-right">
                        <Text size="small" color="secondary">
                            {headerRight}
                        </Text>
                    </div>
                )}
            </header>
            <NewSummaryDetails details={details} />
        </NewRMCard>
    );
};
